import { APP_ENV, type AppEnv } from "@/lib/app-env";
import { VERSION_BASE } from "@/lib/constants/version";

function normalizeBuildVersion(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return `${VERSION_BASE}.local`;
  }

  const withoutLeadingV = trimmed.startsWith("v") ? trimmed.slice(1) : trimmed;
  if (
    withoutLeadingV === VERSION_BASE ||
    withoutLeadingV.startsWith(`${VERSION_BASE}.`) ||
    withoutLeadingV.startsWith(`${VERSION_BASE}-`)
  ) {
    return withoutLeadingV;
  }

  return `${VERSION_BASE}.${withoutLeadingV}`;
}

export function getBuildVersion(): string {
  const rawVersion =
    process.env.NEXT_PUBLIC_SENTRY_RELEASE ||
    process.env.SENTRY_RELEASE ||
    process.env.APP_VERSION ||
    process.env.NEXT_PUBLIC_APP_VERSION ||
    process.env.IMAGE_TAG ||
    process.env.GIT_COMMIT_SHORT ||
    "local";

  return normalizeBuildVersion(rawVersion);
}

export function getEnvironment(): AppEnv {
  return APP_ENV;
}

export function getErrorTimeIso(): string {
  return new Date().toISOString();
}

export function toPublicHost(input?: string | null): string {
  if (!input) return "unknown";

  const value = input.trim();
  if (!value) return "unknown";

  // Try parsing as-is first (works for full URLs like "https://prod2.vidseeds.ai/path")
  try {
    const url = new URL(value);
    return url.host || "unknown";
  } catch {
    // Not a full URL — could be a bare hostname/IP (e.g. "10.101.128.245", "prod2.vidseeds.ai")
  }

  // Prepend protocol and retry for bare hosts/IPs
  try {
    const url = new URL(`http://${value}`);
    return url.host || "unknown";
  } catch {
    // Truly unparseable — return as-is without logging to avoid Sentry recursion
    return value;
  }
}
